module.exports = __webpack_public_path__ + "img/icon.7c57fe49.svg";